export interface HomepageArticle {
  slug: string;
  title: string;
  excerpt: string;
  category: string;
  image: string;
  link: string;
  isInternal: boolean;
}

export const homepageArticles: HomepageArticle[] = [
  {
    slug: 'guida-completa',
    title: 'Itaobuy Spreadsheet: Guida Completa 2026',
    excerpt: "Scopri cos'\u00e8, come funziona e tutte le categorie disponibili nella guida italiana pi\u00f9 completa e aggiornata su Itaobuy Spreadsheet.",
    category: 'Guida',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20minimalist%20guidebook%20and%20laptop%20on%20textured%20linen%20surface%20with%20warm%20candle%20glow%2C%20soft%20natural%20light%2C%20sand%20and%20terracotta%20tones%2C%20editorial%20style%2C%20sophisticated%20composition%20with%20dried%20botanical%20elements&width=600&height=400&seq=hp-article-guida-v2&orientation=landscape',
    link: '/articolo-itaobuy-spreadsheet-guida',
    isInternal: true,
  },
  {
    slug: 'sicurezza',
    title: "Itaobuy Spreadsheet \u00e8 Sicuro? Analisi 2026",
    excerpt: "Analisi approfondita sulla sicurezza della piattaforma: protezione dati, crittografia, privacy e consigli pratici per navigare in totale tranquillit\u00e0.",
    category: 'Sicurezza',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20minimalist%20shield%20and%20lock%20symbols%20on%20clean%20textured%20background%2C%20warm%20ambient%20lighting%2C%20olive%20green%20and%20cream%20tones%2C%20sophisticated%20editorial%20style%2C%20security%20concept%20with%20organic%20plant%20details&width=600&height=400&seq=hp-article-sicurezza-v2&orientation=landscape',
    link: '/articolo-sicurezza-itaobuy-spreadsheet',
    isInternal: true,
  },
  {
    slug: 'confronto',
    title: 'Itaobuy Spreadsheet vs Alternative 2026',
    excerpt: "Confronto dettagliato con le principali alternative: funzionalit\u00e0, categorie, prezzi e valore complessivo per scegliere la piattaforma migliore.",
    category: 'Confronto',
    image: 'https://readdy.ai/api/search-image?query=Two%20elegant%20minimalist%20product%20displays%20side%20by%20side%20on%20light%20wooden%20surface%2C%20warm%20natural%20lighting%2C%20ivory%20and%20sand%20tones%2C%20editorial%20comparison%20concept%2C%20balanced%20composition%20with%20textured%20ceramic%20vase&width=600&height=400&seq=hp-article-confronto-v2&orientation=landscape',
    link: '/articolo-confronto-itaobuy-spreadsheet',
    isInternal: true,
  },
  {
    slug: 'tutorial',
    title: 'Tutorial: Come Usare Itaobuy Spreadsheet',
    excerpt: "Guida passo dopo passo per padroneggiare Itaobuy Spreadsheet: dalla navigazione base ai trucchi avanzati per utenti esperti.",
    category: 'Tutorial',
    image: 'https://readdy.ai/api/search-image?query=Hands%20typing%20on%20laptop%20with%20organized%20notes%20and%20pencil%20on%20clean%20desk%2C%20warm%20morning%20light%2C%20cream%20and%20olive%20tones%2C%20learning%20concept%2C%20editorial%20style%2C%20sophisticated%20composition%20with%20eucalyptus%20sprig&width=600&height=400&seq=hp-article-tutorial-v2&orientation=landscape',
    link: '/articolo-tutorial-itaobuy-spreadsheet',
    isInternal: true,
  },
  {
    slug: 'scarpe-sneakers',
    title: 'Scarpe e Sneakers su Itaobuy Spreadsheet',
    excerpt: "Esplora la collezione completa di scarpe e sneakers disponibili sulla piattaforma. Scopri modelli, tendenze e offerte del momento.",
    category: 'Scarpe',
    image: 'https://readdy.ai/api/search-image?query=Pair%20of%20minimalist%20fashion%20sneakers%20elegantly%20displayed%20on%20textured%20stone%20surface%2C%20soft%20natural%20light%20from%20side%2C%20ivory%20and%20warm%20gray%20tones%2C%20clean%20editorial%20product%20photography%2C%20sophisticated%20composition%20with%20subtle%20shadows&width=600&height=400&seq=hp-article-scarpe-v2&orientation=landscape',
    link: 'https://kaspreadsheet.com/category-911-Shoes.html',
    isInternal: false,
  },
  {
    slug: 'felpe-maglioni',
    title: 'Felpe e Maglioni: Collezione Itaobuy',
    excerpt: "Scopri felpe, maglioni e hoodie di tendenza. La categoria pi\u00f9 calda dell'inverno 2026 su Itaobuy Spreadsheet.",
    category: 'Abbigliamento',
    image: 'https://readdy.ai/api/search-image?query=Soft%20minimalist%20hoodie%20draped%20artistically%20on%20light%20oak%20chair%20with%20warm%20side%20lighting%2C%20cream%20and%20sand%20tones%2C%20clean%20editorial%20fashion%20photography%2C%20cozy%20aesthetic%2C%20sophisticated%20composition%20with%20textured%20throw%20blanket&width=600&height=400&seq=hp-article-felpe-v2&orientation=landscape',
    link: 'https://kaspreadsheet.com/search-912/name/Shoes.html',
    isInternal: false,
  },
  {
    slug: 'giacche-cappotti',
    title: 'Giacche e Cappotti su Itaobuy Spreadsheet',
    excerpt: "La guida alle giacche e ai cappotti disponibili sulla piattaforma. Dalle giacche leggere ai cappotti invernali pi\u00f9 caldi.",
    category: 'Giacche',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20minimalist%20jacket%20on%20wooden%20hanger%20against%20textured%20beige%20wall%2C%20soft%20diffused%20lighting%2C%20warm%20neutral%20tones%2C%20clean%20editorial%20fashion%20photography%2C%20sophisticated%20composition%20with%20dried%20lavender%20bundle&width=600&height=400&seq=hp-article-giacche-v2&orientation=landscape',
    link: 'https://kaspreadsheet.com/search-914/name/Shoes.html',
    isInternal: false,
  },
  {
    slug: 'borse-accessori',
    title: 'Borse e Accessori: Catalogo Completo',
    excerpt: "Borse, cinture, accessori moda e molto altro. Esplora la categoria accessori di Itaobuy Spreadsheet per completare il tuo look.",
    category: 'Accessori',
    image: 'https://readdy.ai/api/search-image?query=Curated%20collection%20of%20minimalist%20fashion%20accessories%20arranged%20on%20marble%20surface%2C%20warm%20natural%20lighting%2C%20ivory%20and%20terracotta%20tones%2C%20editorial%20product%20photography%2C%20elegant%20composition%20with%20golden%20accents%20and%20organic%20elements&width=600&height=400&seq=hp-article-accessori-v2&orientation=landscape',
    link: 'https://kaspreadsheet.com/search-920/name/Shoes.html',
    isInternal: false,
  },
  {
    slug: 'profumi-bellezza',
    title: 'Profumi e Bellezza su Itaobuy Spreadsheet',
    excerpt: "Scopri la selezione di profumi e prodotti beauty sulla piattaforma. Fragranze esclusive e grandi classici a portata di clic.",
    category: 'Profumi',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20minimalist%20perfume%20bottle%20with%20soft%20reflections%20on%20textured%20ceramic%20surface%2C%20warm%20ambient%20lighting%2C%20cream%20and%20olive%20green%20tones%2C%20luxury%20editorial%20product%20photography%2C%20sophisticated%20composition%20with%20dried%20rose%20petals&width=600&height=400&seq=hp-article-profumi-v2&orientation=landscape',
    link: 'https://kaspreadsheet.com/search-923/name/Shoes.html',
    isInternal: false,
  },
];